/**
 * Agent slash command handlers.
 *
 * Each /agent command dispatches a custom event that the ChatPanel
 * (when it exists) listens for. This decouples the slash menu from the
 * chat panel implementation.
 *
 * Event: 'bb-docs:open-agent'
 * Detail: { agentId: string, agentName: string }
 */

/** Agent identifiers that map to the registry keys (without 'agent_' prefix). */
export type AgentId = 'verhaal' | 'sove' | 'kokkin' | 'wetenschap' | 'kaart' | 'ziel';

export interface OpenAgentDetail {
  agentId: AgentId;
  agentName: string;
}

/**
 * Dispatch an event to open the agent chat panel for a specific agent.
 */
export function openAgentChat(agentId: AgentId, agentName: string): void {
  const event = new CustomEvent<OpenAgentDetail>('bb-docs:open-agent', {
    detail: { agentId, agentName },
    bubbles: true,
  });
  window.dispatchEvent(event);
}

/**
 * Extract agent ID from a registry key like 'agent_verhaal' -> 'verhaal'.
 */
export function agentIdFromKey(key: string): AgentId {
  return key.replace('agent_', '') as AgentId;
}

/**
 * Get display name for an agent ID.
 */
export function agentDisplayName(agentId: AgentId): string {
  const names: Record<AgentId, string> = {
    verhaal: 'Verhaal',
    sove: 'Sove',
    kokkin: 'Kokkin',
    wetenschap: 'Wetenschap',
    kaart: 'Kaart',
    ziel: 'Ziel',
  };
  return names[agentId] || agentId;
}
